/* v93 NIGHT SHIFT: gift finder routing, Rusty's reactions, scroll reveal, one Cash moment.
   No dependencies. Everything still works with JS off (the form posts to /collections/all). */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  root.classList.add('ns-js');
  if (document.body) document.body.classList.add('ns-home');

  /* where each answer goes; budget becomes a price filter */
  var ROUTES = {
    mom: '/collections/gifts-for-mom-under-40',
    dad: '/collections/gifts-for-dad',
    couple: '/collections/personalized-christmas-gifts',
    grand: '/collections/gifts-for-grandparents',
    space: '/collections/space-ornaments',
    goth: '/collections/halloween',
    any: '/collections/all'
  };
  var LINES = {
    mom: ['Mom? The name mug. Trust me.', 'Moms love a hat with their name on it. I checked.'],
    dad: ['Dads want a hat that says Papa. Science.', 'Get him the space one. He will explain it to you.'],
    couple: ['Engaged people cry at ornaments. Good crying.', 'Put both names on it. Romance.'],
    grand: ['Grandparents like big print. And us.', 'Family name blanket. Instant favorite grandkid.'],
    space: ['It is a real nebula. I licked the screen.', 'Glass planets. Do not throw them. I learned.'],
    goth: ['The raven listens. I talk a lot.', 'Spooky all year. Not just October.'],
    any: ['Impossible? Try the glass one.', 'Everything here is my favorite. Cash disagrees.']
  };
  var CASH = { '25': 'Cash says: excellent budget.', '40': 'Cash says: sensible.', '75': 'Cash says: bold. Respect.', '': 'Whatever it takes? Cash has left the chat.' };

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var hero = document.querySelector('.ns-hero');
    if (hero) requestAnimationFrame(function () { setTimeout(function () { hero.classList.add('ns-ready'); }, RM ? 0 : 150); });

    var f = document.querySelector('[data-ns-finder]');
    if (f) {
      var who = f.querySelector('[data-ns-who]'), bud = f.querySelector('[data-ns-budget]');
      var bub = document.querySelector('[data-ns-bubble]');
      var n = 0;
      function say(t) {
        if (!bub) return;
        bub.textContent = t;
        bub.classList.remove('is-new');
        if (!RM) { void bub.offsetWidth; bub.classList.add('is-new'); }
      }
      /* size each select to its chosen words, not its longest option */
      var meas = document.createElement('span');
      meas.setAttribute('aria-hidden', 'true');
      meas.style.cssText = 'position:absolute;visibility:hidden;white-space:pre;left:-9999px;top:0';
      document.body.appendChild(meas);
      function fit(sel) {
        var cs = getComputedStyle(sel);
        meas.style.font = cs.font; meas.style.letterSpacing = cs.letterSpacing;
        meas.textContent = sel.options[sel.selectedIndex].text;
        sel.style.width = Math.ceil(meas.offsetWidth + parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight) + 4) + 'px';
      }
      [who, bud].forEach(function (s) { fit(s); s.addEventListener('change', function () { fit(s); }); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(who); fit(bud); });
      who.addEventListener('change', function () { var l = LINES[who.value] || LINES.any; say(l[n++ % l.length]); });
      bud.addEventListener('change', function () { say(CASH[bud.value] || CASH['']); });
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var url = ROUTES[who.value] || ROUTES.any, b = bud.value;
        if (b) url += (url.indexOf('?') > -1 ? '&' : '?') + 'filter.v.price.lte=' + b + '&sort_by=best-selling';
        window.location.href = url;
      });
    }

    var rv = document.querySelectorAll('.ns-rv');
    if ('IntersectionObserver' in window && !RM) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      rv.forEach(function (el) { io.observe(el); });
    } else {
      rv.forEach(function (el) { el.classList.add('is-in'); });
    }
  });
})();
